import { ClearOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Space } from "antd";
import { useCallback } from "react";
import { OrganizationTreeSelect } from "@/modules/organization-cross-access/components/OrganizationTreeSelect";

interface DashboardFilterProps {
	organizationId: string | null;
	onOrganizationChange: (id: string | null, name?: string) => void;
	onReset: () => void;
}

export function DashboardFilter({
	organizationId,
	onOrganizationChange,
	onReset,
}: DashboardFilterProps) {
	const handleChange = useCallback(
		(id: string | undefined, name?: string) => {
			onOrganizationChange(id ?? null, name);
		},
		[onOrganizationChange]
	);

	return (
		<Form layout="vertical" className="mb-6 bg-white p-4 rounded-lg shadow-sm">
			<Row gutter={[16, 0]} align="bottom">
				<Col xs={24} sm={16} md={16}>
					<Form.Item
						label={
							<Space size={4}>
								<TeamOutlined style={{ color: "#1677ff" }} />
								<span>Tashkilot</span>
							</Space>
						}
						style={{ marginBottom: 0 }}
					>
						<OrganizationTreeSelect value={organizationId ?? undefined} onChange={handleChange} />
					</Form.Item>
				</Col>

				<Col xs={24} sm={8} md={8}>
					<Form.Item label=" " style={{ marginBottom: 0 }}>
						<Space className="w-full" style={{ justifyContent: "flex-end" }}>
							<Button
								icon={<ClearOutlined />}
								onClick={onReset}
								disabled={!organizationId}
								style={{ borderRadius: 8 }}
							>
								Tozalash
							</Button>
						</Space>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
}
